import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import AgeonLogo from '../../components/AgeonLogo';

const FOOTER_LINKS = {
    Programmes: [
        { label: 'Therapies', href: '#therapies' },
        { label: 'Membership', href: '#membership' },
        { label: 'Platform', href: '#platform' },
    ],
    Company: [
        { label: 'About', href: '#founder' },
        { label: 'Leadership', href: '#leadership' },
        { label: 'Achievers', href: '#achievers' },
        { label: 'Franchises', href: '#franchises' },
        { label: 'Network', href: '#network' },
    ],
};

export default function LandingFooter({ dashHref }) {
    return (
        <footer className="bg-ink-900 text-white">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-16 lg:pt-20 pb-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
                    <div className="lg:col-span-2">
                        <AgeonLogo variant="white" />
                        <p className="text-sm text-white/50 mt-6 max-w-sm leading-[1.8]">
                            India&rsquo;s premium longevity infrastructure. An EBG Group company —
                            clinical, calm, architectural.
                        </p>
                        <div className="mt-6 flex flex-wrap gap-4 text-sm">
                            <a href="https://ageon.in" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-white/70 hover:text-brand-teal transition">
                                ageon.in <ArrowUpRight className="h-3.5 w-3.5" />
                            </a>
                            <a href="https://theebg.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-white/70 hover:text-brand-teal transition">
                                theebg.com <ArrowUpRight className="h-3.5 w-3.5" />
                            </a>
                        </div>
                    </div>

                    {Object.entries(FOOTER_LINKS).map(([title, links]) => (
                        <div key={title}>
                            <div className="text-[10px] uppercase tracking-[0.22em] text-white/35 font-semibold mb-5">{title}</div>
                            <ul className="space-y-3 text-sm">
                                {links.map(l => (
                                    <li key={l.href}>
                                        <a href={l.href} className="text-white/70 hover:text-brand-teal transition">{l.label}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
                    <span>© {new Date().getFullYear()} AGEON · Longevity &amp; Recovery</span>
                    <Link to={dashHref} className="text-white/50 hover:text-brand-teal transition">Dashboard</Link>
                </div>
            </div>
        </footer>
    );
}
